<template>
    <div class="container h-100">



<!--        <div class="row align-items-center h-100">-->
<!--            <div class="col-12 text-center mx-auto">-->

<!--                <form action="#" @submit.prevent="login">-->
<!--                    <div class="form-group row">-->
<!--                        <label for="email" class="col-md-4 col-form-label text-md-right">Email</label>-->

<!--                        <div class="col-md-6">-->
<!--                            <input-->
<!--                                    id="email"-->
<!--                                    type="email"-->
<!--                                    class="form-control"-->
<!--                                    name="email"-->
<!--                                    value-->
<!--                                    required-->
<!--                                    autofocus-->
<!--                                    v-model="email"-->
<!--                            />-->
<!--                        </div>-->
<!--                    </div>-->

<!--                    <div class="form-group row">-->
<!--                        <label for="password" class="col-md-4 col-form-label text-md-right">Password</label>-->

<!--                        <div class="col-md-6">-->
<!--                            <input-->
<!--                                    id="password"-->
<!--                                    type="password"-->
<!--                                    class="form-control"-->
<!--                                    name="password"-->
<!--                                    required-->
<!--                                    v-model="password"-->
<!--                            />-->
<!--                        </div>-->
<!--                    </div>-->

<!--                    <div class="form-group row mb-0">-->
<!--                        <div class="col-md-8 offset-md-4">-->
<!--                            <button type="submit" class="btn btn-primary">Login</button>-->
<!--                        </div>-->
<!--                    </div>-->
<!--                </form>-->


<!--                <a class="btn btn-primary btn-lg text-white mb-auto loginWithGoogle" @click="signInWithGoogle"><i-->
<!--                        class="fab fa-google"></i> Prijavi se</a>-->
<!--            </div>-->
<!--        </div>-->

        <!-- Modal Start -->
        <div class="modal fade modal-center load-active d-block" id="login" tabindex="-1" role="dialog" style="opacity: 1;">
            <div class="modal-dialog modal-lg" role="document">
                <div class="modal-content">
                    <Loading :active.sync="isLoading"
                             :can-cancel="false"
                             :is-full-page="false"></Loading>

                    <div class="modal-body no-pdd">
                        <div class="login-panel pdd-horizon-15 pdd-vertical-30">
                            <div class="row">
                                <div class="col-md-6 col-sm-6">
                                    <div class="left-panel border right">
                                        <h3 class="mrg-btm-30 mrg-top-15">Prijava</h3>
                                        <form action="#" @submit.prevent="login">
                                            <div class="form-wrapper">
                                                <label><b>Uporabniško ime</b></label>
                                                <input
                                                        id="email"
                                                        type="email"
                                                        class="form-control"
                                                        name="email"
                                                        value
                                                        required
                                                        autofocus
                                                        v-model="email"
                                                />
                                            </div>
                                            <div class="form-wrapper">
                                                <label><b>Geslo</b></label>
                                                <input
                                                        id="password"
                                                        type="password"
                                                        class="form-control"
                                                        name="password"
                                                        required
                                                        v-model="password"
                                                />
                                            </div>

                                            <button type="submit" class="btn btn-primary">Prijava</button>
                                        </form>
                                    </div>
                                </div>
                                <div class="col-md-6 col-sm-6">
                                    <img src="@/assets/images/logo.png" class="logo_img mt-5" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- Modal End -->

    </div>
</template>

<script>
    import firebase from 'firebase'
    import {db} from '../main'
    import Loading from 'vue-loading-overlay'
    import 'vue-loading-overlay/dist/vue-loading.css'

    export default {
        name: 'login',
        components: {
            Loading
        },
        data: function () {
            return {
                email: "",
                password: "",
                error: null,
                isLoading: false
            }
        },
        beforeCreate: function () {
            document.body.className = 'login'
        },
        destroyed: function () {
            document.body.className = ''
        },
        methods: {
            login() {
                const _this = this

                _this.isLoading = true

                firebase.auth().setPersistence(firebase.auth.Auth.Persistence.SESSION)
                    .then(function () {
                        // Existing and future Auth states are now persisted in the current
                        // session only. Closing the window would clear any existing state even
                        // if a user forgets to sign out.
                        // ...
                        // New sign-in will be persisted with session persistence.
                        return firebase.auth().signInWithEmailAndPassword(_this.email, _this.password).then(function (res) {
                            _this.setLoggedUserData(res)
                        })
                    })
                    .catch(function (error) {
                        // Handle Errors here.
                        let errorCode = error.code
                        let errorMessage = error.message
                        _this.isLoading = false
                        console.error(errorCode, errorMessage)
                        _this.$swal('Napaka', 'Poskušate se prijaviti z neveljavnim uporabniškimi podatki!', 'error', {dangerMode: true})
                    })
            },
            signInWithGoogle() {
                const _this = this

                const provider = new firebase.auth.GoogleAuthProvider()

                firebase.auth().signInWithPopup(provider).then((res) => {
                    console.log('res', res)

                    if (res.user.email.split('@')[1] === 'dobra-pot.si') {
                        _this.setLoggedUserData(res)
                    } else {
                        _this.$swal('Napaka', 'Poskušate se prijaviti z neveljavnim uporabniškim računom!', 'error', {dangerMode: true})
                    }

                }).catch((error) => {
                    console.error('error', error)
                })
            },
            setLoggedUserData(userResp) {
                const _this = this

                const users = db.collection('users')
                console.log('userResp', userResp)

                users.where('email', '==', userResp.user.email)
                    .get()
                    .then(function (querySnapshot) {

                            querySnapshot.forEach(function (doc) {

                                console.log('doc', doc)

                                let userData = doc.data()
                                console.log('userData', userData)

                                let userSessionData = {
                                    id: userData.id,
                                    email: userData.email,
                                    displayName: userData.displayName,
                                    administrator: userData.administrator,
                                    userTokeName: 'firebase:authUser:' + userResp.user.l + ':' + userResp.user.m
                                }

                                _this.$store.dispatch('setCurrentlySelectedUser', userData.id);

                                firebase.auth().currentUser.getIdToken(true).then(function (idToken) {

                                    sessionStorage.setItem('HRAM_user', JSON.stringify(userSessionData))

                                    let p1 = _this.$store.dispatch('retrieveUserDetails')

                                    Promise.all([p1]).then((values) => {
                                        _this.isLoading = false
                                        if (userData.administrator) {
                                            _this.$router.push({name: 'Tools'});
                                        } else {
                                            _this.$router.push({name: 'Tools'});
                                        }
                                    })

                                }).catch(function (error) {
                                    console.error('Could not retrieve current user\'s token!')
                                    _this.isLoading = false
                                })
                            })
                        }
                    )
                    .catch(function (error) {
                        console.log('Error getting documents: ', error);
                        _this.isLoading = false;
                    })

            }
        }
        // methods: {
        //   login () {
        //     const _this = this
        //
        //     _this.isLoading = true;
        //
        //     firebase.auth().setPersistence(firebase.auth.Auth.Persistence.SESSION)
        //       .then(function () {
        //         // Existing and future Auth states are now persisted in the current
        //         // session only. Closing the window would clear any existing state even
        //         // if a user forgets to sign out.
        //         // ...
        //         // New sign-in will be persisted with session persistence.
        //         return firebase.auth().signInWithEmailAndPassword(_this.email, _this.password).then(function (res) {
        //           _this.setLoggedUserData(res)
        //         })
        //       })
        //       .catch(function (error) {
        //         // Handle Errors here.
        //         let errorCode = error.code
        //         let errorMessage = error.message
        //         _this.isLoading = false
        //         console.error(errorCode, errorMessage)
        //       })
        //   },
        //   setLoggedUserData (userResp) {
        //     const _this = this
        //
        //     const users = db.collection('users')
        //     console.log('userResp', userResp)
        //
        //     users.where('email', '==', userResp.user.email)
        //       .get()
        //       .then(function (querySnapshot) {
        //
        //         querySnapshot.forEach(function (doc) {
        //
        //           console.log('doc', doc)
        //
        //           let userData = doc.data()
        //           console.log('userData', userData)
        //
        //           let userSessionData = {
        //             email: userData.email,
        //             first_name: userData.first_name,
        //             last_name: userData.last_name,
        //             photo: userData.photo,
        //             id: userData.id,
        //             role: userData.role,
        //             administrator: userData.administrator,
        //             userTokeName: 'firebase:authUser:' + userResp.user.l + ':' + userResp.user.m
        //           }
        //
        //           firebase.auth().currentUser.getIdToken(true).then(function (idToken) {
        //
        //             sessionStorage.setItem('HRAM_user', JSON.stringify(userSessionData))
        //
        //             let p1 = _this.$store.dispatch('retrieveUserDetails')
        //             let p2 = _this.$store.dispatch('retrieveProjects')
        //             let p3 =_this.$store.dispatch('retrieveUsers')
        //             let p4 =_this.$store.dispatch('retrieveEvents')
        //             let p5 =_this.$store.dispatch('retrieveRoles')
        //
        //             Promise.all([p1, p2, p3, p4, p5]).then((values) => {
        //               _this.isLoading = false;
        //               _this.$router.replace('/dogodki')
        //             });
        //
        //           }).catch(function (error) {
        //             console.error('Could not retireve current user\'s token!')
        //           })
        //         })
        //       })
        //       .catch(function (error) {
        //         console.log('Error getting documents: ', error)
        //       })
        //
        //   }
        // }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/Login.vue